import { GetUniformLocation } from './utils/pipeline-utils-gl';
import { fragSamplerMask } from '../shaders/frag-sampler-mask.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { BaseUniformData } from './pipeline-base';
import { TexturePipelineBase } from './pipeline-texBase';

export class MaskedTexturePipeline extends TexturePipelineBase {
  public invertMaskEffect: boolean;

  public constructor(invertMaskEffect: boolean) {
    super(vertSampler, fragSamplerMask);

    this.invertMaskEffect = invertMaskEffect;
  }

  protected getMainSamplerCount(): number {
    return 2;
  }

  public CreateTextures(imgDataList: ImageData[]): WebGLTexture[] {
    if (imgDataList.length !== 2) {
      throw new Error(`CreateTextures called without exactly 2 textures.`);
    }

    return super.CreateTextures(imgDataList);
  }

  protected InitShaderProps(shaderProgram: WebGLProgram) {
    super.InitShaderProps(shaderProgram);

    this.shaderProgramProps.u_invertMaskAlpha = GetUniformLocation(
      this.gl,
      shaderProgram,
      'uInvertMaskAlpha',
      this.constructor.name
    );
  }

  protected SetUniforms(data: BaseUniformData) {
    super.SetUniforms(data);

    this.gl.uniform1i(this.shaderProgramProps.u_invertMaskAlpha, Number(this.invertMaskEffect));
  }
}
